import { BaseEventBuilder } from '@droidmap/shared-service-contract'

import { FeedbackReport } from '../models/feedback.js'
import { User } from '../models/user.js'

const serviceSource = 'droidmap.backend.user-service'

export const UserCreated = new BaseEventBuilder<User, 'User Created'>(
  serviceSource,
  'User Created',
)

export const UserDeleted = new BaseEventBuilder<User, 'User Deleted'>(
  serviceSource,
  'User Deleted',
)

export const UserUpdated = new BaseEventBuilder<User, 'User Updated'>(
  serviceSource,
  'User Updated',
)

/**
 * A customer submitted an in-app support / feedback report. Carries the
 * client's submission plus the identity resolved from the session. Consumed
 * by the notification service, which posts it to the Slack channel for its
 * type.
 *
 * The detail contains free-text written by a customer — treat it as PII and
 * never log it verbatim.
 */
export const FeedbackSubmitted = new BaseEventBuilder<
  FeedbackReport,
  'Feedback Submitted'
>(serviceSource, 'Feedback Submitted')
